import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatBRL } from "@/lib/api";
import { absUrl } from "@/lib/urls";
import { Trash2 } from "lucide-react";

export default function Cart() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-xl mx-auto py-24 px-6 text-center" data-testid="cart-empty">
        <h1 className="font-display text-3xl text-[#49392F]">Seu carrinho está vazio</h1>
        <p className="mt-4 text-[#49392F]/70 text-[14px]">Que tal começar por nossas peças mais desejadas?</p>
        <Link to="/catalogo" className="duo-btn duo-btn-primary mt-8 inline-flex">Explorar catálogo</Link>
      </div>
    );
  }

  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12" data-testid="cart-page">
      <h1 className="font-display text-4xl text-[#49392F] mb-10">Seu carrinho</h1>
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-10">
        <div className="space-y-6">
          {items.map((i) => {
            const key = `${i.product_id}-${i.size || ""}-${i.variation || ""}`;
            return (
              <div key={key} className="flex gap-5 pb-6 border-b border-[#C2A064]/20" data-testid={`cart-item-${i.product_id}`}>
                <div className="w-24 h-28 bg-white overflow-hidden flex-shrink-0">
                  <img src={absUrl(i.image) || "https://images.unsplash.com/photo-1611652022419-a9419f74343d?w=400"} alt={i.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1">
                  <Link to={`/produto/${i.slug || i.product_id}`} className="font-display text-lg text-[#49392F] hover:text-[#C2A064]">{i.name}</Link>
                  <div className="text-[12px] text-[#49392F]/70 mt-1">
                    {[i.size && `Tamanho ${i.size}`, i.variation].filter(Boolean).join(" • ")}
                  </div>
                  <div className="mt-4 flex items-center gap-4">
                    <div className="flex items-center border border-[#E8DCCB]">
                      <button onClick={() => updateQty(key, i.quantity - 1)} className="w-8 h-9 text-[#49392F]">−</button>
                      <span className="w-8 text-center text-[13px]">{i.quantity}</span>
                      <button onClick={() => updateQty(key, i.quantity + 1)} className="w-8 h-9 text-[#49392F]">+</button>
                    </div>
                    <button onClick={() => removeItem(key)} className="text-[#49392F]/60 hover:text-[#49392F]" aria-label="remover" data-testid={`remove-${i.product_id}`}>
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[#49392F] font-medium">{formatBRL(i.unit_price * i.quantity)}</div>
                  <div className="text-[12px] text-[#49392F]/60 mt-1">{formatBRL(i.unit_price)} un.</div>
                </div>
              </div>
            );
          })}
        </div>

        <aside className="bg-white border border-[#C2A064]/20 p-8 h-fit lg:sticky lg:top-32">
          <h3 className="font-display text-xl text-[#49392F]">Resumo</h3>
          <div className="hairline my-5" />
          <div className="flex justify-between text-[14px] text-[#49392F] mb-2">
            <span>Subtotal</span><span>{formatBRL(subtotal)}</span>
          </div>
          <div className="text-[12px] text-[#49392F]/60 mb-5">O valor do frete será combinado pelo WhatsApp.</div>
          <button onClick={() => navigate("/checkout")} className="duo-btn duo-btn-primary w-full" data-testid="checkout-button">
            Finalizar pedido
          </button>
          <Link to="/catalogo" className="duo-btn duo-btn-secondary w-full mt-3">Continuar comprando</Link>
        </aside>
      </div>
    </div>
  );
}
